import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#00B69B',
        },
        secondary: {
            main: '#6c757d',
        },
    },
});

export default theme;
